function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { isPreRelease } from '@finect/front-utils/isPreRelease';
import { useTheme } from 'styled-components';
import { AbsoluteInner, AbsoluteClose } from './Interstitial/partials';
import { GooglePublisherTag, GooglePublisherTagOld } from './GooglePublisherTag';
import { adsDefinition } from './adsDefinition';
export var Ads = function Ads(_ref) {
  var id = _ref.id,
    _ref$targeting = _ref.targeting,
    targeting = _ref$targeting === void 0 ? {} : _ref$targeting,
    _ref$closeable = _ref.closeable,
    closeable = _ref$closeable === void 0 ? false : _ref$closeable,
    responsiveProp = _ref.responsive,
    autorefreshProp = _ref.autorefresh;
  if (typeof window === 'undefined') return null;
  var theme = useTheme();
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isRendered = _useState4[0],
    setIsRendered = _useState4[1];
  var definition = adsDefinition.find(function (def) {
    return def.id === id;
  });
  if (!definition) return null;
  var path = definition.path,
    dimensions = definition.dimensions,
    _definition$enableSin = definition.enableSingleRequest,
    enableSingleRequest = _definition$enableSin === void 0 ? true : _definition$enableSin,
    _definition$collapseE = definition.collapseEmptyDiv,
    collapseEmptyDiv = _definition$collapseE === void 0 ? true : _definition$collapseE,
    _definition$canBeLowe = definition.canBeLower,
    canBeLower = _definition$canBeLowe === void 0 ? true : _definition$canBeLowe,
    _definition$responsiv = definition.responsive,
    responsive = _definition$responsiv === void 0 ? false : _definition$responsiv,
    _definition$higherOnl = definition.higherOnly,
    higherOnly = _definition$higherOnl === void 0 ? false : _definition$higherOnl,
    _definition$autorefre = definition.autorefresh,
    autorefresh = _definition$autorefre === void 0 ? false : _definition$autorefre;
  var computedDimensions = typeof dimensions === 'function' ? dimensions() : dimensions;
  var _theme$partner$consum = theme.partner.consumer,
    consumer = _theme$partner$consum === void 0 ? 'finect' : _theme$partner$consum;
  var defaultTargeting = {
    partner: consumer,
    test: isPreRelease ? '1' : '0'
  };
  var isResponsive = typeof responsiveProp === 'undefined' ? responsive : responsiveProp;
  var isAutorefresh = typeof autorefreshProp === 'undefined' ? autorefresh : autorefreshProp;
  var targetingProps = _objectSpread(_objectSpread(_objectSpread({}, defaultTargeting), targeting), isAutorefresh ? {
    refresh: true
  } : {});
  if (!open) return null;
  var Component = isPreRelease ? GooglePublisherTag : GooglePublisherTagOld;
  if (closeable) {
    return React.createElement(AbsoluteInner, {
      $open: open
    }, isRendered && React.createElement(AbsoluteClose, {
      onClick: function onClick() {
        return setOpen(false);
      }
    }), React.createElement(Component, {
      path: path,
      responsive: isResponsive,
      autorefresh: isAutorefresh,
      dimensions: computedDimensions,
      enableSingleRequest: enableSingleRequest,
      collapseEmptyDiv: collapseEmptyDiv,
      onSlotRenderEnded: function onSlotRenderEnded(evt) {
        evt && !evt.isEmpty && setIsRendered(true);
      },
      canBeLower: canBeLower,
      targeting: targetingProps,
      higherOnly: higherOnly,
      isRendered: isRendered,
      setIsRendered: setIsRendered
    }));
  }
  return React.createElement(Component, {
    path: path,
    responsive: isResponsive,
    autorefresh: isAutorefresh,
    dimensions: computedDimensions,
    enableSingleRequest: enableSingleRequest,
    collapseEmptyDiv: collapseEmptyDiv,
    canBeLower: canBeLower,
    targeting: targetingProps,
    higherOnly: higherOnly
  });
};